import React from 'react';
import FormSelectContain from '../../../Componant/Forms/FormWidget/FormSelect2';

const FormCustomSelect = () => {
  return (
    <div className='page-body'>
      <FormSelectContain />
    </div>
  );
};

export default FormCustomSelect;
